<template>
    <!-- <div class="rule-pop" v-forbid-scroll> -->
    <div :class="['rule-pop', { 'show-rulePop': isShowRulePop }]">
        <div class="rule-bg-box">
            <div class="clr-btn" @click="clrBtnClick">
                <img src="@/assets/clr_btn.png" />
            </div>
            <div class="rule-bg"></div>

            <div class="rule-txt">
                <img src="@/assets/rule_txt.png" />
            </div>

            <!-- <a class="rule-desc" :href="ruleDescLinkHref"></a> -->
        </div>


    </div>
</template>
  
<script>

import store from '@/store';
import Vuex from 'vuex'


//映射 store参数
var mapGetters = Vuex.mapGetters;

export default {
    name: 'RulePop',
    data() {
        return {
            // isShowRulePop: false
        };
    },
    props: {

    },
    methods: {
        //活动规则
        clrBtnClick() {
            this.$store.commit('hideRulePop');
        }
    },
    computed: {
        ...mapGetters([
            'ruleDescLink' // 映射 Vuex 中的 externalLink 状态
        ]),
        // 使用 mapGetters 辅助函数来映射 Vuex getter 到计算属性
        isShowRulePop: function () {
            return this.$store.getters.isShowRulePop;
        }

        // ruleDescLinkHref:function(){
        //     return this.$store.getters.ruleDescLink;
        // }

    }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

@import '@/static/preboot.less';
@import '@/static/JAnimate.less';

.rule-pop {
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: (1681/@rem);
    background-color: rgba(0, 0, 0, 0.8);
    padding: 0;
    margin: 0;
    display: none;
}

.rule-bg-box {
    position: absolute;
    left: (52/@rem);
    top: (117/@rem);
    // top: 50%;
    width: (646/@rem);
    height: (1352/@rem);
    // transform: translateY(-((1301/2)/@rem));
}

.rule-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: (646/@rem);
    height: (1372/@rem);
    background-image: url("../assets/rule_bg.png");
    background-size: contain;
    background-repeat: no-repeat;
    margin-bottom: (117/@rem);
}

.rule-txt {
    position: absolute;
    left: (53/@rem);
    top: (257/@rem);
    width: (545/@rem);
    height: (1043/@rem);
}

img {
    width: 100%;
}

.clr-btn {
    position: absolute;
    right: (51/@rem);
    top: (1363/@rem);
    width: (80/@rem);
    height: (80/@rem);

  .animation(ScaleS2B2S 1s linear infinite);
}

// .rule-desc{
//     position: absolute;
//     width: (170/@rem);
//     height: (43/@rem);
//     top: (524/@rem);
//     left: (163/@rem);
// }

.show-rulePop {
    display: block !important;
}
</style> 